export const defaultParameters = {
    delta: {
        init: (data) => data.signal.delta,
        min: (data) => data.signal.delta - data.shape.fwhm * 2,
        max: (data) => data.signal.delta + data.shape.fwhm * 2,
        gradientDifference: () => 2e-3,
    },
    intensity: {
        init: (data) => data.signal.intensity || 1,
        min: () => 0,
        max: () => 1.5,
        gradientDifference: () => 1e-3,
    },
    fwhm: {
        init: (data) => data.shape.fwhm,
        min: (data) => data.shape.fwhm * 0.25,
        max: (data) => data.shape.fwhm * 4,
        gradientDifference: (data) => data.shape.fwhm * 2e-3,
    },
    mu: {
        init: (data) => data.shape.mu || 0.5,
        min: () => 0,
        max: () => 1,
        gradientDifference: () => 0.01,
    },
    coupling: {
        init: (data) => data.jCoupling.coupling,
        min: (data) => data.jCoupling.coupling * 0.8,
        max: (data) => data.jCoupling.coupling * 1.2,
        gradientDifference: () => 0.01,
    },
};
//# sourceMappingURL=defaultParameters.js.map